module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "track-list"
  }, _vm._l((_vm.$store.state.tracks), function(track) {
    return _c('li', {
      key: track.name
    }, [_c('a', {
      attrs: {
        "href": track.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(track.name))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5717268"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracks.vue
// module id = 63
// module chunks = 1